export default "__VITE_PUBLIC_ASSET__d84e8c34__"